import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormModule} from "../../../../../../form/form.module";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IDialogComponent} from "../../../../../dialog/iDialog.component";
import {DialogWithInput} from "../../../../../dialog/dialogWithInput";
import {DialogModule} from "../../../../../dialog/dialog.module";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";
import {RichTextEditorModule} from "../../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {ButtonModule} from "../../../../../../core/component/button/button.module";
import {AudioTranscriptionService} from "../audio-transcription/audio-transcription.service";
import {Subscription} from "rxjs";
import {InputTextareaModule} from "../../../../../../core/component/input-textarea/input-textarea.module";

export interface AudioTranscriptionDialogInput {
    stopRecordingTooltip: string;
    service: AudioTranscriptionService;
}

export interface AudioTranscriptionDialogOutput {
    text: string;
}

@Component({
  templateUrl: './audio-transcription-dialog.component.html',
  standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        FormFieldModule,
        ButtonModule,
        InputTextareaModule
    ]
})
export class AudioTranscriptionDialogComponent implements
    IDialogComponent<AudioTranscriptionDialogInput, AudioTranscriptionDialogOutput>,
    OnInit,
    OnDestroy {
    dialog: DialogWithInput<AudioTranscriptionDialogInput, AudioTranscriptionDialogOutput>;
    formGroup: FormGroup;
    subscriptions: Subscription[] = [];
    transcriptionInProgress = false;

    constructor(formBuilder: FormBuilder) {
        this.formGroup = formBuilder.group({
            text: new FormControl(undefined)
        });
    }

    stopRecording() {
        this.dialog.close({
            text: this.formGroup.get('text').value
        });
    }

    ngOnInit() {
        this.subscriptions.push(this.dialog.input.service.transcription$.subscribe(transcription => {
          this.formGroup.patchValue({
            text: transcription
          });
        }));
        this.subscriptions.push(this.dialog.input.service.transcriptionInProgress$.subscribe(value => {
            this.transcriptionInProgress = value;
        }))
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
